import { PasoEnum } from "./MainTabsPage";

type ButtonEvent = React.MouseEvent<HTMLDivElement>;

export interface ITab {
    paso:PasoEnum,
    titulo:string,
    order:number,
    orderMd:number,
    pasoActivo:boolean,
    fn:(paso:PasoEnum)=> void
}

export const Tab = ({paso, titulo, order, orderMd, pasoActivo, fn}:ITab ) => {

    return(
        <div className={ 'col-12 col-md-3 pl-1 pr-1 text-center order-md-'+orderMd+' order-'+order} >
            <div className={'tab paso ' + (pasoActivo === true ? 'tab-active':'') } onClick={(e:ButtonEvent)=>{fn(paso);}}>
                {titulo}
            </div>
        </div>
    );
}